module.exports = __webpack_public_path__ + "static/media/userPlaceholder.dadf6e7a.svg";